import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store,history } from "./redux/store";
import App from "./App";
import { SYSTEM_ACTIONS } from "./redux/system/actions";
import "./i18n";
import moment from "moment-timezone";
import { ConnectedRouter } from 'connected-react-router'
import { ErrorBoundary } from './services/bugsnag'

// Dispatch an action that bootstraps our app.
store.dispatch(SYSTEM_ACTIONS.appStarting());

const target = document.querySelector("#root");

moment.tz.setDefault("Europe/Brussels");

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App/>
      </ConnectedRouter>
    </Provider>
  </ErrorBoundary>,
  target
);
